module.exports = __webpack_public_path__ + "img/40_77.52ee3256.png";